import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useAppNavigate from '../../hooks/useAppNavigate';
import { Formik } from 'formik';
import ErrorMessage from '../../form/ErrorMessage';
import { bootcampPurchaseSchema } from '../../../utils/schema';
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { handlePurchaseBootCamp } from '../../../redux/features/coach/actions/authAction';

const BootcampPurchaseModal = ({ onClose, ID, handleClose }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const normalizePhoneValue = (value) => {
        if (!value) return "";
        const trimmed = String(value).trim();
        if (!trimmed) return "";
        if (trimmed.startsWith("+")) return trimmed;
        const digits = trimmed.replace(/\D/g, "");
        if (!digits) return "";
        return `+${digits}`;
    };

    const initialValues = {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "+230",
        bootcamp_id: ID ?? ""
    };

    const handleLogin = async (values) => {
        const callback = (response) => {
            if (response.success) {
                handleClose();
            };
        };
        dispatch(handlePurchaseBootCamp({ payload: values, callback }));
    };

    return (
        <div
            className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
            tabIndex="-1"
        >
            <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
                <div class="modal-content" style={{
                    maxWidth: "1000px",
                    marginInline: "auto"
                }}>
                    <div class="modal-header border-0 p-0 pb-2">
                        <button
                            type="button"
                            class="btn-close ct_close_position_right12"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body pe-0">
                        <section class="ct_signup_main py-3">
                            <div class="container-fluid">
                                <div class="row align-items-center">
                                    <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                                        <div class="ct_signup_left_img">
                                            <img src="../assets/img/Rectangle4179.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 mx-auto pe-0">
                                        <div class="ct_signup_right_content px-5 ct_custom_scroll">
                                            <div class="ct_signup_logo mb-3">
                                                <img src="../assets/img/Nuvio_logo.png" alt="" />
                                            </div>
                                            <div class="mt-0 text-center">
                                                <h2 class="ct_fs_32  mb-0 ct_darkblue_text mx-auto" style={{ maxWidth: "484px" }}>
                                                    Hi! Welcome to the <span className='ct_darksky_blue_text'>Nuvio</span> <span className='ct_yellow_text'>Bootcamp!</span>
                                                </h2>
                                            </div>
                                            <Formik
                                                initialValues={initialValues}
                                                validationSchema={bootcampPurchaseSchema}
                                                enableReinitialize
                                                onSubmit={(values, actions) => {
                                                    handleLogin(values);
                                                }}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    setFieldValue,
                                                    setFieldError,
                                                }) => (
                                                    <form onSubmit={handleSubmit} class="mt-5">
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                                <div class="form-group mb-4">
                                                                    <label class="mb-2 d-block ct_darkblue_text">
                                                                        First Name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control ct_input"
                                                                        placeholder="First Name"
                                                                        id="first_name"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.first_name}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="first_name"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <div class="form-group mb-4">
                                                                    <label class="mb-2 d-block ct_darkblue_text">
                                                                        Last Name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control ct_input"
                                                                        placeholder="Last Name"
                                                                        id="last_name"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.last_name}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="last_name"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-4">
                                                                    <label class="mb-2 d-block ct_darkblue_text">
                                                                        Email
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control ct_input"
                                                                        placeholder="Email"
                                                                        id="email"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.email}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="email"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-3">
                                                                    <label

                                                                        class="mb-2 d-block ct_darkblue_text"
                                                                    >
                                                                        Phone Number
                                                                    </label>
                                                                    <PhoneInput
                                                                        id="phone_number"
                                                                        className="form-control ct_input ct_input_grey_border_1 ct_border_radius_5 ct_h_44"
                                                                        defaultCountry="MU"
                                                                        value={normalizePhoneValue(values?.phone_number)}
                                                                        onChange={(val) => {
                                                                            const safeVal = val ?? "";
                                                                            if (
                                                                                typeof safeVal === "string" &&
                                                                                safeVal.length > 2 &&
                                                                                isValidPhoneNumber(safeVal)
                                                                            ) {
                                                                                setFieldValue(
                                                                                    "phone_number",
                                                                                    safeVal
                                                                                );
                                                                            } else if (
                                                                                !isValidPhoneNumber(safeVal)
                                                                            ) {
                                                                                setFieldError(
                                                                                    "phone_number",
                                                                                    "Please enter valid phone number"
                                                                                );
                                                                                setFieldValue(
                                                                                    "phone_number",
                                                                                    safeVal
                                                                                );
                                                                            }
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="phone_number"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-4">
                                                            <a class="ct_yellow_btn w-75 mx-auto ct_sky_blue_btn" onClick={handleSubmit}>
                                                                Confirm My Seat
                                                            </a>
                                                        </div>
                                                    </form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BootcampPurchaseModal;
